<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine> </BaseTopLine>

    <div>
      <VueTabs
        class="vue-tabs-type-1"
        v-model="activeTab"
        @tab-change="handleTabChange"
      >
        <VTab title="Управление" data-name="control">
          <div
            class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px] tw-mt-[15px]"
            ref="topFilter"
          >
            <div class="tw-flex tw-justify-between tw-gap-[20px] tw-text-white">
              <div class="tw-flex tw-items-end tw-gap-[10px]">
                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["tracker_text2"] }}</label
                  >
                  <BaseInputNew
                    @keyupEnter="loadData()"
                    inputClass="tw-app-input-dark"
                    @input="
                      fillFilter($event),
                        (filters.gps__tracker_id.value = $event.value)
                    "
                    :additionalParams="{ type: 'like' }"
                    inputName="gps__tracker_id"
                    :value="filters.gps__tracker_id.value"
                  />
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["tracker_text3"] }}</label
                  >
                  <BaseInputNew
                    @keyupEnter="loadData()"
                    inputClass="tw-app-input-dark"
                    @input="
                      fillFilter($event),
                        (filters.gps__imei.value = $event.value)
                    "
                    :additionalParams="{ type: 'like' }"
                    inputName="gps__imei"
                    :value="filters.gps__imei.value"
                  />
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["tracker_text4"] }}</label
                  >
                  <BaseInputNew
                    @keyupEnter="loadData()"
                    inputClass="tw-app-input-dark"
                    @input="
                      fillFilter($event),
                        (filters.vehicles__gosnumber.value = $event.value)
                    "
                    :additionalParams="{ type: 'like' }"
                    inputName="vehicles__gosnumber"
                    :value="filters.vehicles__gosnumber.value"
                  />
                </div>

                <div class="tw-app-input-container">
                  <label class="tw-app-input-container-label">
                    {{ dataLang["tracker_text17"] }}</label
                  >
                  <BaseInputNew
                    @keyupEnter="loadData()"
                    inputClass="tw-app-input-dark"
                    @input="
                      fillFilter($event),
                        (filters.gps__company_id.value = $event.value)
                    "
                    :additionalParams="{ type: 'like' }"
                    inputName="gps__company_id"
                    :value="filters.gps__company_id.value"
                  />
                </div>

                <div class="tw-flex tw-flex-row">
                  <button @click="loadData(1)" class="tw-app-btn-primary">
                    {{ dataLang["tracker_text1"] }}
                  </button>
                  <button
                    type="button"
                    class="tw-app-btn-light"
                    @click="resetFilter"
                  >
                    Сбросить
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            class="tw-px-[26px] tw-mt-[15px] tw-flex tw-justify-between tw-gap-[10px]"
          >
            <div class="tw-flex tw-flex-grow tw-gap-[10px]">
              <button
                class="tw-app-btn-primary-outline"
                @click="$modal.show('loadFileWithInfo')"
              >
                <img
                  :src="require(`@/assets/icons/to-exel.svg`)"
                  width="16"
                  height="16"
                />
                {{ dataLang["tracker_text18"] }}
              </button>

              <button
                class="tw-app-btn-primary-outline"
                @click="
                  () =>
                    activeSelectRowsMultiple.length
                      ? $modal.show('acceptDeleteModal')
                      : $modal.show('selectRow')
                "
              >
                <img
                  :src="require(`@/assets/icons/adddel.svg`)"
                  width="13.5"
                  height="13.5"
                />
                {{ dataLang["tracker_text9"] }}
              </button>

              <button
                class="tw-app-btn-primary-outline"
                @click="
                  () =>
                    activeSelectRowsMultiple.length
                      ? $modal.show('selectOwner')
                      : $modal.show('selectRow')
                "
              >
                {{ dataLang["tracker_text19"] }}
              </button>

              <button
                class="tw-app-btn-primary-outline"
                @click="
                  () =>
                    activeSelectRowsMultiple.length
                      ? $modal.show('deattachOwnerModal')
                      : $modal.show('selectRow')
                "
              >
                {{ dataLang["tracker_text20"] }}
              </button>

              <a
                href="https://docs.google.com/spreadsheets/d/1vkZuc5tkFOzLz65n0fcsKZFy8zkNlbo9sCM5zfpq6f8/edit#gid=1624217125"
                target="_blank"
                class="tw-app-btn-external !tw-inline-flex"
              >
                {{ dataLang["tracker_text10"] }}
              </a>
            </div>

            <button
              class="tw-app-btn-external"
              @click="() => loadExel('/super/trackers/download/template')"
            >
              {{ dataLang["tracker_text21"] }}
            </button>
          </div>

          <!-- разделитель -->

          <div class="tw-px-[26px] tw-mt-[15px]">
            <div class="tw-flex tw-justify-between">
              <div class="tw-flex">
                <button @click="loadData()" class="tw-app-btn-primary-outline">
                  {{ dataLang["register_btn_filter_on"] }}
                </button>
                <button
                  @click="resetFilter()"
                  class="tw-app-btn-light !tw-text-[#0056AF]"
                >
                  Сбросить
                </button>
              </div>
              <TwBasePagination
                :page-count="numPages"
                :pagination-params="{
                  ...paginationFinesStateParams,
                  limit: limitPaginationValue,
                }"
                :showLimitInput="true"
                @updateLimitValue="updateLimitValue"
                :page-range="10"
                :margin-pages="0"
                :click-handler="loadData"
              >
              </TwBasePagination>
            </div>

            <div class="tw-relative tw-mt-[15px]" style="min-height: 400px">
              <BaseLoader v-if="localLoading"></BaseLoader>

              <ve-table
                class="rest-style-table fixed-header"
                style="width: 100%"
                :columns="columns"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                row-key-field-name="gps__id"
                ref="mainTable"
                :eventCustomOption="eventCustomOption"
                v-if="!localLoading"
                :checkbox-option="{
                  selectedRowChange: selectedRowChange,
                  selectedAllChange: selectedAllChange,
                  hideSelectAll: false,
                }"
                :clickHighlight="false"
                :cell-style-option="cellStyleOption"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              >
              </ve-table>
            </div>
          </div>
        </VTab>
        <VTab title="Трекеры и шаблоны" data-name="trackersTemplates">
          <div class="tw-px-[26px] tw-mt-[15px]">
            <div class="tw-mb-[15px] tw-flex tw-items-center tw-gap-[10px]">
              <button class="tw-app-btn-primary" @click="openAddTemplate">
                <img
                  :src="require(`@/assets/icons/addwhite.svg`)"
                  width="13.5"
                  height="13.5"
                  class="tw-my-[-5px]"
                />
                Добавить
              </button>
              <button
                class="tw-app-btn-primary-outline"
                @click="
                  () =>
                    activeSelectRowsMultiple.length
                      ? $modal.show('deleteTemplate')
                      : $modal.show('selectTemplate')
                "
              >
                <img
                  :src="require(`@/assets/icons/minus-dark.svg`)"
                  width="13.5"
                  height="13.5"
                  class="tw-my-[-5px]"
                />
                Удалить
              </button>
            </div>
          </div>

          <div class="tw-px-[26px]" style="min-height: 400px">
            <ve-table
              class="rest-style-table fixed-header"
              style="width: auto; max-width: 270px; table-layout: fixed"
              row-key-field-name="gps_tracker_templates__id"
              :columns="columnsTrackersTemplate"
              :table-data="dataTrackerTemplate"
              :border-x="true"
              :border-y="true"
              :eventCustomOption="clickTemplatesRow"
              v-if="!localLoading"
              :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false,
              }"
              :clickHighlight="false"
              :cell-style-option="cellStyleOption"
              :rowStyleOption="{
                hoverHighlight: true,
              }"
              :cellSelectionOption="{ enable: false }"
            >
            </ve-table>
          </div>
        </VTab>
      </VueTabs>
    </div>

    <BaseModal
      name="selectOwner"
      width="420"
      :clickToClose="false"
      @beforeClose="() => (selectsFromModal.owners = [])"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('selectOwner')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text52"] }}
          </div>

          <BaseSelect
            class="multiselect-type-3"
            @search-change="companiesSearch = $event"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            v-model="selectsFromModal.owners"
            label="companies__name"
            :custom-label="
              ({ companies__name, companies__id }) => {
                return companies__id
                  ? companies__name + ', ID:' + companies__id
                  : companies__name;
              }
            "
            :options="companiesSearchOptions"
            :maxHeight="84"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('selectOwner')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="addOwner"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text53"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="loadFileWithInfo"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
      @before-close="onClose"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('loadFileWithInfo')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text47"] }}
          </div>

          <label class="tw-app-btn-primary !tw-inline-block tw-mt-[10px]">
            <input
              type="file"
              class="d-none"
              @change="onAttachFile"
              accept=".xlsx"
            />
            {{ dataLang["tracker_text48"] }}
          </label>

          <div class="tw-my-[15px]" v-if="fileLoadResult">
            {{ computedFilesFromData }}
          </div>

          <div v-if="fileLoadResult" class="tw-app-modal__footer">
            <button
              @click="$modal.hide('loadFileWithInfo')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="onSetFile"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="acceptDeleteModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDeleteModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text61"] }}
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDeleteModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="deleteAcceptRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="selectRow"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="tw-app-modal"
    >
      <div
        class="tw-app-modal__container tw-flex tw-justify-center tw-items-center"
      >
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('selectRow')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title tw-max-w-[300px]">
            {{ dataLang["tracker_text57"] }}
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('selectRow')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="deattachOwnerModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deattachOwnerModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text60"] }}
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('deattachOwnerModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text50"] }}
            </button>
            <button
              @click="onDeattachOwner"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successDeattachOwnerModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="295"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successDeattachOwnerModal')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text92"] }}
          </div>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successDeattachOwnerModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorOfDelete"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorOfDelete')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text62']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorOfDelete')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorOfDeattachOwnerModal"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('errorOfDeattachOwnerModal')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text63']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorOfDeattachOwnerModal')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successOfAddOwner"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successOfAddOwner')"
        ></button>

        <div class="tw-text-center">
          <div v-html="dataLang['tracker_text59']"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successOfAddOwner')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successAddTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successAddTracker')"
        ></button>

        <div>
          <div
            class="tw-app-modal__title"
            v-html="dataLang['tracker_text56']"
          ></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successAddTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successDeleteTracker"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successDeleteTracker')"
        ></button>

        <div class="tw-text-center">
          <div
            class="tw-app-modal__title"
            v-html="dataLang['tracker_text54']"
          ></div>

          <div class="tw-h-[5px]"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successDeleteTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="editTracker"
      width="640"
      :clickToClose="false"
      @before-close="selectsFromModal.owners = []"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @beforeClose="closemodal"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('editTracker')"
        ></button>

        <div v-if="!loadingEditTracker">
          <div class="tw-app-modal__title">
            {{ dataLang["tracker_text91"] }}
          </div>

          <div class="tw-text-[14px]">
            <div
              v-for="(item, index) in editTrackerData"
              class="tw-grid tw-grid-cols-[165px_auto]"
            >
              <div
                class="tw-border-0 tw-border-r-[1px] tw-border-solid tw-border-forLine"
              >
                <div class="tw-text-forText tw-py-[6px]">
                  {{ item.title }}
                </div>
              </div>
              <div v-html="item.value" class="tw-px-[10px] tw-py-[6px]"></div>
            </div>
          </div>

          <div class="tw-grid tw-grid-cols-[165px_auto] tw-my-[10px]">
            <div class="tw-text-forText tw-py-[6px]">
              {{ dataLang["tracker_text44"] }}
            </div>
            <BaseInputNew
              inputClass="tw-app-input-type-3"
              placeholder=""
              class="wp-100"
              :width="'415'"
              input-name="gps__canpr"
              :horizontalTitle="true"
              @input="updateValue"
              :value="dataForModal.gps__canpr"
            >
            </BaseInputNew>
          </div>

          <div class="tw-grid tw-grid-cols-[165px_auto] tw-my-[10px]">
            <div class="tw-text-forText tw-py-[6px]">
              {{ dataLang["tracker_text45"] }}
            </div>
            <BaseTextarea
              inputClass="tw-app-input-type-3"
              placeholder=""
              :disabled="true"
              @onInput="updateValue"
              minHeight="54"
              :maxLength="499"
              :resize="false"
              input-name="gps__comment_super_company"
              :value="dataForModal.gps__comment_super_company"
            >
            </BaseTextarea>
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('editTracker')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="saveEditModal"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text53"] }}
            </button>
          </div>
        </div>
        <div
          v-if="loadingEditTracker"
          class="wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
          style="top: 0; left: 0; z-index: 500; min-height: 200px"
        >
          <svg class="spinner" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="editTemplate"
      width="420"
      :clickToClose="false"
      @before-close="selectsFromModal.owners = []"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      @beforeClose="closemodal"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('editTemplate')"
        ></button>

        <div>
          <div class="tw-app-modal__title">Добавить / редактировать</div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Трекер</div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__name"
              input-name="gps_tracker_templates__name"
            >
            </BaseInput>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Gelios Unit Type ID</div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__gelios_type_unit_id"
              input-name="gps_tracker_templates__gelios_type_unit_id"
            >
            </BaseInput>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              Gelios Unit ID (12 вольт)
            </div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__voltage12"
              input-name="gps_tracker_templates__voltage12"
            >
            </BaseInput>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">
              Gelios Unit ID (24 вольт)
            </div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__voltage24"
              input-name="gps_tracker_templates__voltage24"
            >
            </BaseInput>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Команда блокировки</div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__command_block"
              input-name="gps_tracker_templates__command_block"
            >
            </BaseInput>
          </div>

          <div class="tw-mb-[15px]">
            <div class="tw-app-input-type-3-label">Команда разблокировки</div>
            <BaseInput
              inputClass="tw-app-input-type-3"
              @onInput="updateValue"
              :value="dataForModal.gps_tracker_templates__command_unblock"
              input-name="gps_tracker_templates__command_unblock"
            >
            </BaseInput>
          </div>

          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="closeEditTemplate"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="
                () =>
                  templateAction === 'add' ? addTemplate() : saveEditTemplate()
              "
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text53"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="selectTemplate"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('selectTemplate')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            Нужно выбрать хотя бы один шаблон!
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('selectTemplate')"
              class="tw-app-btn-muted"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="deleteTemplate"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('deleteTemplate')"
        ></button>

        <div>
          <div class="tw-app-modal__title">
            Точно безвозвратно удалить выбранные шаблоны?
          </div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('deleteTemplate')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["reestr_fines_text48"] }}
            </button>
            <button
              @click="deleteTemplates"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["tracker_text51"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="successDeleteTemplate"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successDeleteTemplate')"
        ></button>

        <div>
          <div class="tw-app-modal__title">Шаблоны удалены</div>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('successDeleteTemplate')"
              class="tw-app-btn-muted"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal
      name="errorDeleteTemplate"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('successDeleteTemplate')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-my-[15px]" v-html="templateDeleteErr"></div>

          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('errorDeleteTemplate')"
              class="tw-app-btn-muted"
            >
              {{ dataLang["tracker_text55"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import GeneralService from "@/api/GeneralService";
import httpInstance from "@/http-common";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";

export default {
  components: {
    VeTable,
    VTab,
    VueTabs,
  },

  data() {
    return {
      limitPaginationValue: 50,
      filters: {
        gps__company_id: {
          value: null,
        },
        gps__tracker_id: {
          value: null,
        },
        gps__imei: {
          value: null,
        },
        vehicles__gosnumber: {
          value: null,
        },
      },
      loadingEditTracker: false,
      companiesSearch: "",
      templateDeleteErr: "",
      templateAction: "",
      activeTab: "",
      localLoading: true,
      dataTable: [],
      dataTrackerTemplate: [],
      activeSelectRowsMultiple: [],
      filter: [],
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      nameValue: "",
      settingOneClick: {},
      activePagePagination: {},
      currentId: null,
      localLoadingModal: false,
      pincode: "",
      dataForModal: {},
      filesDataFromLoading: null,
      fileLoadResult: null,
      selectsDataForModal: {
        owners: [],
      },
      selectsFromModal: {
        owners: [],
      },
      selectsData: {
        trackers: [],
        statuses: [],
        typeunits: [],
        typeVehicles: [],
      },
      selectsFilter: {
        trackers: [],
        statuses: [],
        typeunits: [],
        typeVehicles: [],
      },
      gelleryList: [],
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.$modal.show("editTracker");
              this.loadingEditTracker = true;
              GeneralService.get("/super/trackers/" + row.gps__id)
                .then((res) => {
                  this.loadingEditTracker = false;
                  this.dataForModal = res?.data?.data?.rows?.[0];
                })
                .catch((e) => {
                  this.loadingEditTracker = false;
                  this.$toast.error("Неизвестная ошибка при загрузке", {
                    duration: 5000,
                  });
                });

              // this.dataForModal = row

              this.selectsFromModal.owners.push(
                this.selectsDataForModal.owners.find(
                  (value) =>
                    value.companies__id == this.dataForModal.gps__company_id
                )
              );
            },
          };
        },
      },
      clickTemplatesRow: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.templateAction = "edit";
              this.dataForModal = row;
              this.$modal.show("editTemplate");
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (column.field == "companies__gelios_balance") {
            return row.settings?.companies__gelios_balance;
          }
        },
      },
    };
  },
  methods: {
    openAddTemplate() {
      this.templateAction = "add";
      this.dataForModal = {};
      this.$modal.show("editTemplate");
    },
    deleteTemplates() {
      GeneralService.delete(
        `/super/trackers-templates/` + this.activeSelectRowsMultiple
      )
        .then((data) => {
          this.loadTemplates();
          this.$modal.hide("deleteTemplate");
          this.$modal.show("successDeleteTemplate");
        })
        .catch((e) => {
          this.templateDeleteErr =
            e?.response?.data?.message ?? "Ошибка удаления";
          this.$modal.hide("deleteTemplate");
          this.$modal.show("errorDeleteTemplate");
        });
    },
    addTemplate() {
      GeneralService.editOrCreate(`/super/trackers-templates`, {
        ...this.updatedValues,
      })
        .then((res) => {
          this.$modal.hide("editTemplate");
          this.loadTemplates();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    saveEditTemplate() {
      GeneralService.edit(
        `/super/trackers-templates/${this.dataForModal.gps_tracker_templates__id}`,
        {
          ...this.updatedValues,
        }
      )
        .then((res) => {
          this.$modal.hide("editTemplate");
          this.loadTemplates();
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    closeEditTemplate() {
      this.$modal.hide("editTemplate");
      this.dataForModal = {};
    },
    handleTabChange(tabIndex, newTab, oldTab) {
      if (newTab.$attrs["data-name"] === "control") return this.loadData();
      else return this.loadTemplates();
    },
    onClose() {
      this.fileLoadResult = null;
      this.filesDataFromLoading = null;
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
    },
    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values);
      let tranaslateLocal = tranaslate;
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        );
      });

      return tranaslateLocal;
    },
    async onAttachFile(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "super_trackers_list_xlsx");

      try {
        let dataFrom = await httpInstance.post("/storage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.fileLoadResult = dataFrom.data.data.url;
        let importFile = await httpInstance.post("/super/trackers/load", {
          file: this.fileLoadResult,
          save: 0,
        });
        this.filesDataFromLoading = this.computedTranslate(
          { count: importFile.data.data.countRows },
          this.dataLang["tracker_text49"]
        );
      } catch (error) {}
    },
    async onSetFile() {
      try {
        let importFile = await httpInstance.post("/super/trackers/load", {
          file: this.fileLoadResult,
          save: 1,
        });
        this.$modal.hide("loadFileWithInfo");
        this.$modal.show("successAddTracker");
        this.loadData();
      } catch (e) {
        this.$toast.error(e.response.data.message, { duration: 5000 });
        this.$modal.hide("loadFileWithInfo");
      }
    },
    async loadExel(urlToFetch) {
      let dataFrom = await httpInstance.get(urlToFetch, {
        responseType: "blob",
      });
      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    saveEditModal() {
      GeneralService.edit(`/super/trackers/${this.dataForModal.gps__id}`, {
        ...this.updatedValues,
      })
        .then((data) => {
          this.$modal.hide("editTracker");
          this.loadData();
        })
        .catch((e) => {
          this.selectsFromModal.owners = [];
          this.$toast.error(e.response.data.message, { duration: 5000 });
        });
    },
    onDeattachOwner() {
      GeneralService.edit(`/super/trackers/detach-owners`, {
        trackersIds: this.activeSelectRowsMultiple,
      })
        .then((data) => {
          this.$modal.hide("deattachOwnerModal");
          this.$modal.show("successDeattachOwnerModal");
          this.loadData();
        })
        .catch((e) => {
          this.$modal.hide("deattachOwnerModal");
          this.$modal.show("errorOfDeattachOwnerModal");
        })
        .finally(() => {
          this.activeSelectRowsMultiple = [];
        });
    },
    addOwner() {
      if (this.selectsFromModal.owners) {
        GeneralService.edit(`/super/trackers/attach-owners`, {
          trackersIds: this.activeSelectRowsMultiple,
          ownerId: this.selectsFromModal.owners.companies__id,
        })
          .then((data) => {
            this.$modal.hide("selectOwner");
            this.$modal.show("successOfAddOwner");
            this.loadData();
          })
          .catch((e) => {
            this.selectsFromModal.owners = [];
            this.activeSelectRowsMultiple = [];
            this.$modal.hide("selectOwner");
            this.$modal.show("errorOfAddOwner");
          });
      }
    },
    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.filter = [];
      this.selectsFilter = {
        trackers: [],
        statuses: [],
        typeunits: [],
        typeVehicles: [],
      };
      this.loadData();
    },
    closemodal() {
      this.currentId = null;
      this.updatedValues = {};
      this.dataForModal = {};
      this.activeSelectRowsMultiple = [];
    },
    deleteActionAndModal() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show("acceptDelete");
      } else {
        this.$modal.show("withoutOptionsModal");
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
    },
    deleteAcceptRow() {
      GeneralService.delete(`/super/trackers/` + this.activeSelectRowsMultiple)
        .then((data) => {
          this.loadData();
          this.$modal.hide("acceptDeleteModal");
          this.$modal.show("successDeleteTracker");
        })
        .catch((e) => {
          this.$modal.hide("acceptDeleteModal");
          this.$modal.show("errorOfDelete");
        });
    },
    loadTemplates() {
      this.localLoading = true;
      GeneralService.get(`/super/trackers-templates`)
        .then((res) => {
          this.dataTrackerTemplate = res.data.data.rows;
        })
        .catch((e) => {
          this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
            duration: 5000,
          });
        })
        .finally(() => (this.localLoading = false));
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    loadData(page = 1) {
      this.localLoading = true;
      Promise.all([
        GeneralService.get(`/super/companies`)
          .then((data) => {
            this.selectsDataForModal.owners = data.data.data.rows;
            this.selectsDataForModal.owners.unshift({
              companies__name: "Не выбрано",
              companies__id: null,
            });
          })
          .catch((e) => {}),

        GeneralService.get(`/super/trackers/selects/statuses`)
          .then((res) => {
            this.selectsData.statuses = Object.entries(res.data.data).map(
              ([value, label]) => ({ value, label })
            );
          })
          .catch((e) => {}),

        GeneralService.get(`/super/trackers/selects/template`)
          .then((res) => {
            this.selectsData.typeunits = Object.entries(res.data.data).map(
              ([value, label]) => ({ value, label })
            );
          })
          .catch((e) => {}),

        GeneralService.get(`/super/trackers/selects/object-types`)
          .then((res) => {
            this.selectsData.typeVehicles = Object.entries(res.data.data).map(
              ([value, label]) => ({ value, label })
            );
          })
          .catch((e) => {}),
      ]).then(() => {
        GeneralService.get(`/super/trackers/table`, {
          params: {
            ...this.paginationFinesStateParams,
            page: page,
            limit: this.limitPaginationValue,
            ...(this.filter.length && { where: JSON.stringify(this.filter) }),
          },
        })
          .then((data) => {
            this.getFinesAll(data.data.data);
            this.dataTable = data.data.data.rows;
            this.localLoading = false;
          })
          .catch((e) => {
            this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
              duration: 5000,
            });
          });
      });
    },
    fillFilter(data) {
      console.log(777, data);
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
          ...(data.operator && { operator: data.operator }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("finesPagination", ["getFinesAll"]),
  },
  mounted() {},
  created() {
    Promise.all([]).then(() => {
      this.loadData();
    });
  },
  computed: {
    editTrackerData() {
      return [
        {
          title: this.dataLang["tracker_text35"],
          value: this.dataLang[this.dataForModal.gps_statuses__name],
        },
        {
          title: this.dataLang["tracker_text36"],
          value: this.dataForModal.gps__tracker_id,
        },
        {
          title: this.dataLang["tracker_text37"],
          value: this.dataForModal.gps_tracker_templates__name,
        },
        {
          title: this.dataLang["tracker_text38"],
          value: this.dataForModal.gps__imei,
        },
        {
          title: this.dataLang["tracker_text26"],
          value: this.dataForModal.gps__gelios_unit_id,
        },
        {
          title: this.dataLang["tracker_text40"],
          value: this.dataLang[this.dataForModal.vehicle_types__code],
        },
        {
          title: this.dataLang["tracker_text41"],
          value: this.dataForModal.vehicles__name,
        },
        {
          title: this.dataLang["tracker_text107"],
          value: this.dataForModal.gps__volt,
        },
        {
          title: this.dataLang["tracker_text42"],
          value: this.dataForModal.gps__sim_phone,
        },
        {
          title: this.dataLang["tracker_text43"],
          value: this.dataForModal.gps__sim_operator,
        },
        {
          title: this.dataLang["tracker_text39"],
          value: this.dataForModal.vehicles__odometr,
        },
        {
          title: this.dataLang["interval_events_for_object_text40"],
          value: this.dataForModal.vehicles__motohour,
        },
        {
          title: this.dataLang["tracker_text46"],
          value: this.selectsFromModal.owners.companies__name
            ? this.selectsFromModal.owners.companies__name
            : "Не назначен",
        },
      ];
    },

    companiesSearchOptions() {
      if (this.companiesSearch) {
        return this.selectsDataForModal?.owners?.filter(
          (i) => i.companies__id == this.companiesSearch
        );
      } else {
        return this.selectsDataForModal?.owners;
      }
    },
    computedFilesFromData() {
      return this.filesDataFromLoading;
    },
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("finesPagination", ["paginationFinesStateParams"]),
    ...mapGetters("finesPagination", ["numPages"]),
    columns() {
      return [
        {
          field: "",
          key: "a6",
          type: "checkbox",
          title: "",
          width: 5,
          align: "center",
        },
        {
          field: "gps_statuses__name",
          key: "1723",
          title: this.dataLang["tracker_text22"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.gps_statuses__name]}</span>;
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.statuses}
                  onInput={(e, w) => {
                    this.fillFilter({
                      name: "gps__status_id",
                      value: e.value,
                    });
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ label }) => {
                    return `${this.dataLang[label]} `;
                  }}
                  options={this.selectsData.statuses}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "gps__tracker_id",
          key: "163",
          title: this.dataLang["tracker_text23"],
          align: "center",
          width: "5%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "gps_tracker_templates__name",
          key: "1533",
          title: "Оборудование",
          align: "center",
          width: "7%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.typeunits}
                  onInput={(e, w) => {
                    this.fillFilter({
                      name: "gps_tracker_templates__id",
                      value: e.value,
                    });
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ label }) => {
                    return `${label} `;
                  }}
                  options={this.selectsData.typeunits}
                ></BaseSelect>
              </div>
            );
          },
        },
        {
          field: "gps__volt",
          key: "volt",
          title: "Вольт",
          align: "center",
          width: "3%",
          ellipsis: { showTitle: false, lineClamp: 1 },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "gps__imei",
          key: "172",
          title: this.dataLang["tracker_text25"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },

          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "gps__gelios_unit_id",
          key: "13746",
          title: this.dataLang["tracker_text26"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "vehicle_types__code",
          key: "16531",
          title: this.dataLang["tracker_text27"],
          align: "center",
          width: "10%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },

          renderHeaderCell: ({ column }, h) => {
            return (
              <div class="multiselect-type-1 multiselect-type-1-small">
                <div class={"text-center"}>{column.title}</div>
                <BaseSelect
                  vModel={this.selectsFilter.typeVehicles}
                  onInput={(e, w) => {
                    this.fillFilter({
                      name: "vehicle_types__id",
                      value: e.value,
                    });
                  }}
                  style={"width: 100%"}
                  placeholder={""}
                  id={"ads__id"}
                  selectLabel={""}
                  deselectLabel={""}
                  customLabel={({ label }) => {
                    return `${this.dataLang[label]} `;
                  }}
                  options={this.selectsData.typeVehicles}
                ></BaseSelect>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.dataLang[row.vehicle_types__code]}</span>;
          },
        },
        {
          field: "vehicles__name",
          key: "163111",
          title: this.dataLang["tracker_text28"],
          align: "center",
          width: "15%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <div style={"height: 25px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicles__name} {row.vehicles__gosnumber}
              </span>
            );
          },
        },
        {
          field: "gps__canpr",
          key: "16315",
          title: this.dataLang["tracker_text29"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "vehicles__odometr",
          key: "12631",
          title: this.dataLang["tracker_text30"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "vehicles__motohour",
          key: "1263112",
          title: this.dataLang["interval_events_for_object_text40"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "gps__company_id",
          key: "16311",
          title: this.dataLang["tracker_text31"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "companies__gelios_balance",
          key: "16331",
          title: this.dataLang["tracker_text15"],
          align: "center",
          width: "5%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
        {
          field: "gps__comment_super_company",
          key: "16431",
          title: this.dataLang["tracker_text32"],
          align: "center",
          width: "20%",

          ellipsis: {
            showTitle: false,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 25px"}></div>
              </div>
            );
          },
        },
      ];
    },
    columnsTrackersTemplate() {
      return [
        {
          field: "",
          key: "checkbox",
          type: "checkbox",
          title: "",
          width: 30,
          align: "center",
        },
        {
          field: "gps_tracker_templates__id",
          key: "id",
          title: "ID",
          align: "center",
          width: 120,
          ellipsis: { showTitle: false, lineClamp: 1 },
        },
        {
          field: "gps_tracker_templates__name",
          key: "name",
          title: "Трекер",
          align: "center",
          width: 120,
          ellipsis: { showTitle: false, lineClamp: 1 },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.indicator {
  display: flex;
  padding: 5px 0;
  border-radius: 5px;
  background-color: #23b14d;
  color: white;
  width: 80px;
  font-size: 11px;
  display: flex;
  justify-content: center;

  &--warn {
    background-color: #ff3a20;
  }
}
</style>
